import { Pipe, PipeTransform } from '@angular/core';
import { ReviewDeletedStatus } from '@vendasta/reputation';
import { Review } from './review-types';

@Pipe({
  name: 'checkReviewDeleted',
  standalone: false,
})
export class CheckReviewDeletedPipe implements PipeTransform {
  transform(review: Review, checkAgainstStatus?: ReviewDeletedStatus): boolean {
    if (checkAgainstStatus || checkAgainstStatus === 0) {
      return review.deletedStatus === checkAgainstStatus;
    }
    return (
      review.deletedStatus === ReviewDeletedStatus.REVIEW_DELETED_STATUS_UNSPECIFIED ||
      review.deletedStatus === ReviewDeletedStatus.REVIEW_DELETED_STATUS_USER_REMOVED
    );
  }
}
